export default __webpack_public_path__ + "static/media/Logs-documentation.8bfa0a38.md";